import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => ({ state: props.state }), [props.state])
}
